import React from 'react';
import SponsorForm from '../components/SponsorForm';

const SponsorPage = () => {
  return <SponsorForm />;
};

export default SponsorPage;
